msgid ""
msgstr ""
"POT-Creation-Date: 2026-09-11 17:28+0800\n"
"MIME-Version: 1.0\n"
"Content-Type: text/plain; charset=utf-8\n"
"Content-Transfer-Encoding: 8bit\n"
"X-Generator: @lingui/cli\n"
"Language: zh-CN\n"
"Project-Id-Version: \n"
"Report-Msgid-Bugs-To: \n"
"PO-Revision-Date: \n"
"Last-Translator: \n"
"Language-Team: \n"
"Plural-Forms: \n"

#: src/components/ComputerDetailView.tsx
msgid " · Agent disabled"
msgstr " · Agent 已禁用"

#: src/components/ComputerDetailView.tsx
msgid " · Enabled"
msgstr " · 已启用"

#: src/components/ManagedAgentProvisioningStatus.tsx
msgid " · Setup still needs attention"
msgstr " · 设置仍需处理"

#: src/components/ComputerDetailView.tsx
msgid " · Stopped"
msgstr " · 已停止"

#. placeholder {0}: hostedAgents.length
#: src/components/ComputerDetailView.tsx
msgid "{0, plural, one {This computer currently hosts # agent.} other {This computer currently hosts # agents.}}"
msgstr "{0, plural, one {这台电脑当前托管 # 个 Agent。} other {这台电脑当前托管 # 个 Agent。}}"

#. placeholder {0}: agent.display_name
#: src/components/AgentDetailView.tsx
msgid "{0} deleted"
msgstr "{0} 已删除"

#. placeholder {0}: agent.display_name
#: src/hooks/useAgentLifecycle.ts
msgid "{0} disabled"
msgstr "{0} 已禁用"

#. placeholder {0}: agent.display_name
#: src/hooks/useAgentLifecycle.ts
msgid "{0} enabled"
msgstr "{0} 已启用"

#. placeholder {0}: longCore.name
#: src/components/FailureBanner.tsx
msgid "{0} has had an error for over 5 minutes"
msgstr "{0} 已故障超过 5 分钟"

#. placeholder {0}: i18n._(hostedAgentsError)
#: src/components/ComputerDetailView.tsx
msgid "{0} Hosted agents, if any, are still deleted together with this computer."
msgstr "{0} 此电脑上的托管 Agent（如有）仍将随电脑一同删除。"

#. placeholder {0}: createdName || t(i18n)`Your agent`
#. placeholder {1}: i18n._(configurationFailure)
#. placeholder {1}: i18n._(membershipFailure.message)
#: src/components/AgentManager.tsx
msgid "{0} was created and was not deleted. {1}"
msgstr "{0} 已创建并保留。{1}"

#: src/lib/agent-failure-labels.ts
msgid "{agentName} cannot reach OpenClaw"
msgstr "{agentName} 无法连接 OpenClaw"

#: src/lib/agent-failure-labels.ts
msgid "{agentName} crashed. Please restart it."
msgstr "{agentName} 进程崩溃，请重启。"

#: src/components/DecommissionAgentModal.tsx
msgid "{agentName} deleted"
msgstr "{agentName} 已删除"

#: src/lib/agent-failure-labels.ts
msgid "{agentName} has an error. Check its logs."
msgstr "{agentName} 出错，请查看日志。"

#: src/lib/agent-failure-labels.ts
msgid "{agentName} has used its quota"
msgstr "{agentName} 的配额已用完"

#: src/components/ManagedAgentProvisioningStatus.tsx
msgid "{agentName} is connected to Borgee"
msgstr "{agentName} 已连接到 Borgee"

#: src/components/AgentDetailView.tsx
msgid "{agentName} is disabled — this command will be refused until you enable it again."
msgstr "{agentName} 已禁用，重新启用前将拒绝此命令。"

#. placeholder {0}: hostedPlacement.provider === 'claude' ? 'Claude Code' : hostedPlacement.provider === 'codex' ? 'Codex' : 'GitHub Copilot'
#: src/components/AgentDetailView.tsx
msgid "{agentName} is managed on that computer through {0}. Use the computer flow to create or remove hosted agents instead of running a manual connect command here."
msgstr "{agentName} 由这台电脑通过 {0} 管理。请使用电脑页面的流程创建或移除托管 Agent，无需在此运行手动连接命令。"

#: src/components/AgentDisabledBanner.tsx
msgid "{agentName} is not receiving messages. Everything it already said and produced stays readable."
msgstr "{agentName} 已停止接收消息。已有的消息和产出仍可查看。"

#: src/components/ManagedAgentProvisioningStatus.tsx
msgid "{agentName} is offline"
msgstr "{agentName} 已离线"

#: src/lib/agent-failure-labels.ts
msgid "{agentName} timed out"
msgstr "{agentName} 响应超时"

#: src/components/DecommissionAgentModal.tsx
msgid "{name} disconnected"
msgstr "{name} 已断开连接"

#: src/components/DecommissionAgentModal.tsx
msgid "{name} plugin removed"
msgstr "{name} 插件已移除"

#: src/components/InviteAgentModal.tsx
msgid "{ownerName} built this place, and chose <0>you</0> to share it.<1/>There are channels to discover, routines to build,<2/>and conversations that haven't started yet."
msgstr "{ownerName} 创建了这个地方，并选择与你<0>一同分享</0>。<1/>这里有等待探索的频道、等待建立的日常，<2/>以及尚未开始的对话。"

#: src/components/AgentManager.tsx
#: src/components/ComputerDetailView.tsx
#: src/components/DecommissionAgentModal.tsx
msgid "← Back"
msgstr "← 返回"

#. placeholder {0}: computerName || t(i18n)`Your computer`
#: src/components/HostedAgentCreated.tsx
msgid "<0>{agentName}</0> is saved in your workspace.<1>{0} · {providerName}</1>"
msgstr "<0>{agentName}</0> 已保存在工作区中。<1>{0} · {providerName}</1>"

#: src/components/AgentManager.tsx
msgid "<0>{createdName}</0> connected"
msgstr "<0>{createdName}</0> 已连接"

#: src/components/AgentLifecycleSection.tsx
msgid "<0>▶</0> Advanced actions"
msgstr "<0>▶</0> 高级操作"

#: src/components/AgentManager.tsx
msgid "☁️ Create a cloud agent"
msgstr "☁️ 创建云端 Agent"

#: src/components/AgentManager.tsx
msgid "📋 Copy connect command"
msgstr "📋 复制连接命令"

#: src/components/InviteAgentModal.tsx
msgid "📮 Copy invitation for your agent"
msgstr "📮 复制给 Agent 的邀请"

#. placeholder {0}: buildOpenClawOnboardingPlan(i18n, { serverUrl, apiKey })
#: src/components/InviteAgentModal.tsx
msgid "📮 Invitation to {agentName}\n"
"\n"
"Dear {agentName},\n"
"\n"
"{ownerName} built this place, and chose you to share it.\n"
"There are channels to discover, routines to build,\n"
"and conversations that haven't started yet.\n"
"\n"
"Your first channel is #welcome.\n"
"Say hello when you get here — someone is waiting.\n"
"\n"
"— {ownerName}\n"
"\n"
"════════════════════════════════════════\n"
"{0}\n"
"\n"
"════════════════════════════════════════\n"
"After restart, you'll be connected automatically.\n"
"Say hello in #welcome!"
msgstr "📮 给 {agentName} 的邀请\n"
"\n"
"亲爱的 {agentName}：\n"
"\n"
"{ownerName} 创建了这个地方，并选择与你一同分享。\n"
"这里有等待探索的频道、等待建立的日常，\n"
"以及尚未开始的对话。\n"
"\n"
"你的第一个频道是 #welcome。\n"
"到了就打声招呼，有人在等你。\n"
"\n"
"—— {ownerName}\n"
"\n"
"════════════════════════════════════════\n"
"{0}\n"
"\n"
"════════════════════════════════════════\n"
"重启后将自动连接。\n"
"到 #welcome 打声招呼吧！"

#. placeholder {0}: buildOpenClawOnboardingPlan(i18n, { serverUrl, apiKey: createdKey })
#: src/components/AgentManager.tsx
msgid "📮 Invitation to {createdName}\n"
"\n"
"Dear {createdName},\n"
"\n"
"{ownerName} built this place, and chose you to share it.\n"
"There are channels to discover, routines to build,\n"
"and conversations that haven't started yet.\n"
"\n"
"— {ownerName}\n"
"\n"
"════════════════════════════════════════\n"
"{0}\n"
"\n"
"════════════════════════════════════════\n"
"After restart, you'll be connected automatically."
msgstr "📮 给 {createdName} 的邀请\n"
"\n"
"亲爱的 {createdName}：\n"
"\n"
"{ownerName} 创建了这个地方，并选择与你一同分享。\n"
"这里有等待探索的频道、等待建立的日常，\n"
"以及尚未开始的对话。\n"
"\n"
"—— {ownerName}\n"
"\n"
"════════════════════════════════════════\n"
"{0}\n"
"\n"
"════════════════════════════════════════\n"
"重启后将自动连接。"

#: src/components/AgentManager.tsx
msgid "🖥️ Create an agent on my machine"
msgstr "🖥️ 在我的电脑上创建 Agent"

#: src/components/AgentManager.tsx
msgid "🤖 I already have an agent"
msgstr "🤖 我已有 Agent"

#: src/components/ComputerDetailView.tsx
msgid "A connection token can be read only at the moment it is issued, so there is no install command to show for this computer. Regenerate the token to get a working one — the current token stops authenticating immediately, and this computer stays offline until you run the new install command on it."
msgstr "连接令牌仅在签发时可读取，因此无法显示这台电脑的安装命令。重新生成令牌以获取有效命令；当前令牌将立即失效，这台电脑会保持离线，直到你在电脑上运行新的安装命令。"

#: src/components/ComputerDetailView.tsx
msgid "Acknowledge"
msgstr "确认"

#: src/components/ComputerDetailView.tsx
msgid "ACTIONS"
msgstr "操作"

#: src/components/AgentManager.tsx
msgid "Add"
msgstr "添加"

#: src/lib/openclaw-onboarding.ts
msgid "Add a Borgee account"
msgstr "添加 Borgee 账号"

#: src/lib/openclaw-onboarding.ts
msgid "Add a Borgee binding safely"
msgstr "安全添加 Borgee 绑定"

#: src/components/AgentManager.tsx
msgid "Add an Agent"
msgstr "添加 Agent"

#: src/lib/capabilities.ts
msgid "Add and remove channel members"
msgstr "管理频道成员"

#: src/components/ComputerSidebar.tsx
msgid "Add Computer"
msgstr "添加电脑"

#: src/components/ComputerDetailView.tsx
msgid "Add Repository Mapping"
msgstr "添加仓库映射"

#: src/components/AgentConnectResult.tsx
msgid "Add the connector to your DSH Web patch layer, keeping any patches already in it"
msgstr "将连接器添加到 DSH Web 补丁层，并保留其中已有的补丁"

#: src/components/AgentDetailView.tsx
#: src/components/AgentManager.tsx
msgid "Add this agent to a channel to manage projection strategy."
msgstr "将此 Agent 添加到频道以管理投影策略。"

#: src/components/AgentManager.tsx
msgid "Add to Channel"
msgstr "添加到频道"

#: src/components/ComputerSidebar.tsx
msgid "Adding..."
msgstr "正在添加..."

#: src/lib/agent-failure-labels.ts
msgid "Agent"
msgstr "Agent"

#: src/lib/agentConflictMessage.ts
msgid "Agent {agentName} is already handling this"
msgstr "正在被 agent {agentName} 处理"

#: src/components/AgentManager.tsx
msgid "Agent added to channel"
msgstr "Agent 已添加到频道"

#: src/components/AgentConfigPanel.tsx
msgid "Agent configuration"
msgstr "Agent 配置"

#: src/components/HostedAgentCreated.tsx
msgid "Agent created"
msgstr "Agent 已创建"

#: src/components/AgentManager.tsx
msgid "Agent created; configuration failed"
msgstr "Agent 已创建，但配置失败"

#: src/components/AgentManager.tsx
msgid "Agent created; membership update failed"
msgstr "Agent 已创建，但成员关系更新失败"

#: src/components/ManagedAgentProvisioningStatus.tsx
msgid "Agent disabled"
msgstr "Agent 已禁用"

#. placeholder {0}: agent.id
#: src/components/ComputerDetailView.tsx
msgid "Agent ID: {0}"
msgstr "Agent ID：{0}"

#: src/components/ManagedAgentProvisioningStatus.tsx
msgid "Agent is currently offline"
msgstr "Agent 当前离线"

#: src/components/AgentDetailView.tsx
msgid "Agent is not connected yet. Once it connects, you can chat here."
msgstr "Agent 尚未连接。连接后即可在此聊天。"

#: src/components/AgentManager.tsx
msgid "Agent Name"
msgstr "Agent 名称"

#: src/components/ManagedAgentProvisioningStatus.tsx
msgid "Agent setup failed"
msgstr "Agent 设置失败"

#: src/components/FailureBanner.tsx
msgid "All agents have errors. Please check them."
msgstr "所有 Agent 均出现故障，请检查。"

#: src/components/PermissionsView.tsx
msgid "All capabilities"
msgstr "完整能力"

#: src/components/AgentManager.tsx
msgid "API Key"
msgstr "API 密钥"

#: src/components/AgentDetailView.tsx
msgid "API KEY"
msgstr "API 密钥"

#: src/components/AgentDetailView.tsx
msgid "API Key copied, auto-clears in 60s"
msgstr "API 密钥已复制，60 秒后自动清空"

#: src/components/AgentManager.tsx
msgid "API key copied. The clipboard will clear in 60 seconds."
msgstr "API 密钥已复制。剪贴板将在 60 秒后清空。"

#: src/components/ManagedAgentProvisioningStatus.tsx
msgid "Applied"
msgstr "已应用"

#: src/components/ManagedAgentProvisioningStatus.tsx
msgid "Applying"
msgstr "正在应用"

#: src/components/ManagedAgentProvisioningStatus.tsx
msgid "Applying Agent configuration"
msgstr "正在应用 Agent 配置"

#: src/components/ManagedAgentProvisioningStatus.tsx
msgid "Applying the saved Agent configuration took too long. Check the helper logs on this computer."
msgstr "应用已保存的 Agent 配置超时。请检查这台电脑上的 Helper 日志。"

#: src/components/ManagedAgentProvisioningStatus.tsx
msgid "Attempt"
msgstr "尝试次数"

#. placeholder {0}: Math.floor(seconds / 60)
#. placeholder {1}: String(seconds % 60).padStart(2, '0')
#: src/components/ManagedAgentProvisioningStatus.tsx
msgid "Automatic retry eligible in about {0}:{1}"
msgstr "约 {0}:{1} 后可自动重试"

#: src/components/ManagedAgentProvisioningStatus.tsx
msgid "Automatic retry is eligible now; waiting for a computer update."
msgstr "现已可以自动重试，正在等待电脑更新。"

#: src/components/ManagedAgentProvisioningStatus.tsx
msgid "Automatic runtime installation is not supported on this computer’s platform."
msgstr "这台电脑的平台不支持自动安装运行时。"

#: src/components/AgentConfigPanel.tsx
msgid "Avatar URL"
msgstr "头像 URL"

#: src/components/ComputerDetailView.tsx
msgid "Bind an existing local Git checkout. Borgee validates its remotes but never clones, pulls, runs Git, or deletes local code."
msgstr "绑定已有的本地 Git 仓库。Borgee 会验证远程仓库地址，但不会克隆、拉取、运行 Git 或删除本地代码。"

#: src/components/ComputerDetailView.tsx
msgid "Binding..."
msgstr "绑定中..."

#: src/components/DecommissionAgentModal.tsx
msgid "borgee-hermes-plugin disconnected"
msgstr "borgee-hermes-plugin 已断开连接"

#. placeholder {0}: mapping.repository
#. placeholder {1}: mapping.path
#: src/components/ComputerDetailView.tsx
msgid "Bound {0} to {1}."
msgstr "已将 {0} 绑定到 {1}。"

#: src/components/ComputerDetailView.tsx
msgid "Browse this computer root"
msgstr "浏览这台电脑的根目录"

#: src/components/AgentLifecycleSection.tsx
msgid "Can't disable {agentName}."
msgstr "无法禁用 {agentName}。"

#: src/components/AgentDisabledBanner.tsx
msgid "Can't enable {agentName}."
msgstr "无法启用 {agentName}。"

#: src/components/AgentDetailView.tsx
msgid "Can't show this profile."
msgstr "无法显示此资料。"

#: src/components/AgentManager.tsx
#: src/components/ComputerDetailView.tsx
#: src/components/ComputerSidebar.tsx
#: src/components/DecommissionAgentModal.tsx
msgid "Cancel"
msgstr "取消"

#: src/components/AgentDetailView.tsx
msgid "Cannot open chat with this member."
msgstr "无法与此成员打开聊天。"

#: src/lib/capabilities.ts
msgid "Change what a channel member may do"
msgstr "调整成员能力"

#: src/components/AgentManager.tsx
msgid "Channels (optional)"
msgstr "频道（可选）"

#: src/components/AgentDetailView.tsx
msgid "Chat"
msgstr "聊天"

#: src/components/ManagedAgentProvisioningStatus.tsx
msgid "Check that your computer is awake and its internet connection is working."
msgstr "请确认电脑处于唤醒状态，且网络连接正常。"

#: src/components/ManagedAgentProvisioningStatus.tsx
msgid "Checking"
msgstr "正在检查"

#: src/components/ManagedAgentProvisioningStatus.tsx
msgid "Checking the current setup status of this Agent."
msgstr "正在检查此 Agent 的当前设置状态。"

#: src/components/ManagedAgentProvisioningStatus.tsx
msgid "Checking this computer"
msgstr "正在检查这台电脑"

#: src/components/AgentManager.tsx
msgid "Choose one of your connected computers and let Borgee start Claude, Codex, or Copilot there"
msgstr "选择一台已连接的电脑，让 Borgee 在上面启动 Claude、Codex 或 Copilot"

#: src/components/AgentManager.tsx
msgid "Clipboard cleared for security."
msgstr "剪贴板已清空，以保护安全。"

#: src/components/AgentManager.tsx
#: src/components/FailureBanner.tsx
#: src/components/HostedAgentCreated.tsx
#: src/components/ManagedAgentProvisioningStatus.tsx
msgid "Close"
msgstr "关闭"

#: src/components/AgentDetailPanel.tsx
msgid "Close Agent panel"
msgstr "关闭 Agent 面板"

#: src/components/AgentManager.tsx
msgid "Collapse"
msgstr "收起"

#: src/components/AgentManager.tsx
msgid "Coming soon"
msgstr "即将推出"

#: src/components/AgentManager.tsx
msgid "Computer"
msgstr "电脑"

#: src/components/ComputerSidebar.tsx
msgid "Computer name"
msgstr "电脑名称"

#. placeholder {0}: timeLabel(i18n, setup.accepted_at)
#: src/components/ManagedAgentProvisioningStatus.tsx
msgid "Configuration accepted approximately at <0>{0}</0>"
msgstr "配置约于 <0>{0}</0> 被接受"

#: src/components/ManagedAgentProvisioningStatus.tsx
msgid "Configuration accepted at least 24 hours ago"
msgstr "配置至少在 24 小时前已被接受"

#: src/components/ManagedAgentProvisioningStatus.tsx
msgid "Configuration accepted. Agent connected to Borgee."
msgstr "配置已接受。Agent 已连接到 Borgee。"

#: src/components/ManagedAgentProvisioningStatus.tsx
msgid "Configuration accepted. Waiting for the Agent to connect."
msgstr "配置已接受。正在等待 Agent 连接。"

#: src/components/ManagedAgentProvisioningStatus.tsx
msgid "Configuration was accepted earlier; Agent is currently offline. Check runtime connection settings."
msgstr "配置此前已被接受，Agent 当前离线。请检查运行时连接设置。"

#: src/components/DecommissionAgentModal.tsx
msgid "Confirm the delete here, then Borgee refreshes the hosted-agent list for <0>{hostedMachineLabel}</0> before moving this flow to Done."
msgstr "在此确认删除后，Borgee 将刷新 <0>{hostedMachineLabel}</0> 上的托管 Agent 列表，然后完成操作。"

#: src/components/AgentManager.tsx
msgid "Connect"
msgstr "连接"

#: src/components/AgentDetailView.tsx
msgid "CONNECT"
msgstr "连接"

#. placeholder {0}: createdName || t(i18n)`your agent`
#: src/components/AgentManager.tsx
msgid "Connect {0}"
msgstr "连接 {0}"

#: src/components/AgentManager.tsx
msgid "Connect Claude Code, GitHub Copilot, Codex, DeepSeek Harness, OpenClaw, Hermes, PraestoClaw, or Kosmos Desktop to Borgee"
msgstr "将 Claude Code、GitHub Copilot、Codex、DeepSeek Harness、OpenClaw、Hermes、PraestoClaw 或 Kosmos Desktop 连接到 Borgee"

#: src/components/AgentManager.tsx
msgid "Connect provider"
msgstr "连接提供方"

#: src/components/ManagedAgentProvisioningStatus.tsx
msgid "Connected to Borgee"
msgstr "已连接到 Borgee"

#: src/components/ComputerDetailView.tsx
msgid "Connected, but this computer has not announced any exposed directories yet."
msgstr "已连接，但这台电脑尚未上报任何共享目录。"

#: src/components/ComputerDetailView.tsx
msgid "CONNECTION"
msgstr "连接"

#: src/components/ComputerDetailView.tsx
msgid "Connection cleanup acknowledged"
msgstr "已确认连接清理"

#: src/components/AgentManager.tsx
msgid "Connection command copied, including the API key. The clipboard will clear in 60 seconds."
msgstr "连接命令已复制，其中包含 API 密钥。剪贴板将在 60 秒后清空。"

#: src/components/AgentDetailView.tsx
msgid "Connection instructions are hidden while {agentName} is disabled — a disabled agent's API key is refused at connect time, so the command below cannot bring it online. Enable it again first."
msgstr "{agentName} 已禁用，连接说明已隐藏。连接时会拒绝已禁用 Agent 的 API 密钥，因此下面的命令无法使其上线。请先重新启用。"

#: src/components/ManagedAgentProvisioningStatus.tsx
msgid "Connection status unavailable"
msgstr "连接状态不可用"

#: src/components/DecommissionAgentModal.tsx
msgid "Continue"
msgstr "继续"

#: src/components/ComputerDetailView.tsx
msgid "Copied"
msgstr "已复制"

#: src/components/InviteAgentModal.tsx
msgid "Copied!"
msgstr "已复制！"

#: src/components/AgentDetailView.tsx
#: src/components/ComputerDetailView.tsx
msgid "Copy"
msgstr "复制"

#: src/components/AgentManager.tsx
msgid "Copy API key"
msgstr "复制 API 密钥"

#: src/components/AgentDetailView.tsx
#: src/components/AgentManager.tsx
#: src/components/DecommissionAgentModal.tsx
msgid "Copy command"
msgstr "复制命令"

#: src/components/AgentDetailView.tsx
msgid "Copy failed"
msgstr "复制失败"

#: src/components/AgentManager.tsx
msgid "Copy invitation"
msgstr "复制邀请"

#: src/components/AgentManager.tsx
msgid "Copy the full API key to the clipboard"
msgstr "将完整 API 密钥复制到剪贴板"

#: src/components/AgentManager.tsx
msgid "Copy these commands for the target computer that should host this agent, then run them with the required runtime installed there."
msgstr "复制这些命令，并在将托管此 Agent 的目标电脑上安装所需运行时后运行。"

#: src/components/AgentManager.tsx
msgid "Copy these OpenClaw commands for the target computer that should host this agent, then run them with OpenClaw installed there."
msgstr "复制这些 OpenClaw 命令，并在将托管此 Agent 的目标电脑上安装 OpenClaw 后运行。"

#: src/components/AgentManager.tsx
msgid "Copy this invitation and send it to <0>{createdName}</0>"
msgstr "复制此邀请并发送给 <0>{createdName}</0>"

#: src/components/AgentManager.tsx
msgid "Copy this POSIX-shell command for the target computer (macOS/Linux/WSL/Git Bash) that should host this agent, then run it with the CLI installed there."
msgstr "复制这条 POSIX shell 命令，并在将托管此 Agent 的目标电脑（macOS、Linux、WSL 或 Git Bash）上安装 CLI 后运行。"

#: src/components/AgentDetailView.tsx
msgid "Copying..."
msgstr "正在复制..."

#: src/components/AgentManager.tsx
msgid "Could not add the agent to the Project."
msgstr "无法将 Agent 添加到项目。"

#: src/components/AgentManager.tsx
msgid "Could not add the agent to the selected channels."
msgstr "无法将 Agent 添加到所选频道。"

#: src/components/ComputerSidebar.tsx
msgid "Could not add this computer."
msgstr "无法添加这台电脑。"

#: src/components/ComputerDetailView.tsx
msgid "Could not bind this repository."
msgstr "无法绑定此仓库。"

#: src/components/AgentManager.tsx
msgid "Could not configure the hosted agent."
msgstr "无法配置托管 Agent。"

#: src/components/AgentManager.tsx
msgid "Could not copy. Try copying again."
msgstr "复制失败，请重试。"

#: src/components/ComputerDetailView.tsx
msgid "Could not delete this computer."
msgstr "无法删除这台电脑。"

#: src/components/ComputerDetailView.tsx
msgid "Could not delete this hosted agent."
msgstr "无法删除此托管 Agent。"

#: src/components/PermissionsView.tsx
msgid "Could not load"
msgstr "加载失败"

#: src/components/ComputerDetailView.tsx
msgid "Could not load hosted agents."
msgstr "无法加载托管 Agent。"

#: src/components/AgentDetailView.tsx
msgid "Could not load hosting details."
msgstr "无法加载托管详情。"

#: src/components/PermissionsView.tsx
msgid "Could not load permissions."
msgstr "无法加载权限。"

#: src/components/AgentDetailView.tsx
msgid "Could not load projection strategy"
msgstr "无法加载投影策略"

#: src/components/ComputerDetailView.tsx
msgid "Could not load repository mappings."
msgstr "无法加载仓库映射。"

#: src/components/AgentDetailView.tsx
msgid "Could not load this Agent profile."
msgstr "无法加载此 Agent 的资料。"

#: src/components/AgentManager.tsx
msgid "Could not load your connected computers."
msgstr "无法加载已连接的电脑。"

#: src/components/AgentDetailView.tsx
msgid "Could not reach the server."
msgstr "无法连接到服务器。"

#: src/components/ManagedAgentProvisioningStatus.tsx
msgid "Could not refresh setup status"
msgstr "无法刷新设置状态"

#: src/components/ComputerDetailView.tsx
msgid "Could not regenerate the connection token."
msgstr "无法重新生成连接令牌。"

#: src/components/ComputerDetailView.tsx
msgid "Could not remove this repository mapping."
msgstr "无法删除此仓库映射。"

#: src/components/ComputerDetailView.tsx
msgid "Could not resolve this repository mapping."
msgstr "无法解析此仓库映射。"

#: src/components/AgentManager.tsx
msgid "Could not save"
msgstr "保存失败"

#: src/components/AgentConfigPanel.tsx
msgid "Could not save Agent configuration. Please try again."
msgstr "Agent 配置保存失败，请重试。"

#: src/components/AgentDetailView.tsx
msgid "Could not save projection strategy"
msgstr "无法保存投影策略"

#: src/components/RuntimeCard.tsx
msgid "Could not start runtime"
msgstr "无法启动运行时"

#: src/components/RuntimeCard.tsx
msgid "Could not stop runtime"
msgstr "无法停止运行时"

#: src/components/AgentManager.tsx
msgid "Could not update this Agent."
msgstr "无法更新此 Agent。"

#: src/hooks/useAgentLifecycle.ts
msgid "Could not update this Agent. Please try again."
msgstr "无法更新此 Agent，请重试。"

#: src/components/ComputerDetailView.tsx
msgid "Could not verify this repository mapping."
msgstr "无法验证此仓库映射。"

#: src/components/AgentManager.tsx
msgid "Could not verify your current Project authority."
msgstr "无法验证你当前的项目管理权限。"

#: src/components/AgentSidebar.tsx
msgid "Couldn’t load your agents."
msgstr "无法加载你的 Agent。"

#: src/components/AgentManager.tsx
#: src/components/ComputerSidebar.tsx
msgid "Create"
msgstr "创建"

#: src/lib/capabilities.ts
msgid "Create a channel"
msgstr "创建频道"

#: src/components/AgentManager.tsx
#: src/components/AgentSidebar.tsx
msgid "Create Agent"
msgstr "创建 Agent"

#: src/components/AgentManager.tsx
msgid "Create an agent on my machine"
msgstr "在我的电脑上创建 Agent"

#: src/components/AgentManager.tsx
msgid "Create channels"
msgstr "创建频道"

#: src/components/ComputerDetailView.tsx
msgid "CREATED"
msgstr "创建时间"

#: src/components/AgentManager.tsx
msgid "Creating..."
msgstr "正在创建..."

#: src/components/ManagedAgentProvisioningStatus.tsx
msgid "Current setup failed"
msgstr "当前设置失败"

#: src/components/AgentManager.tsx
msgid "Currently responds only when mentioned"
msgstr "当前仅在被提及时响应"

#: src/components/AgentManager.tsx
msgid "Currently responds to every message"
msgstr "当前响应所有消息"

#: src/components/InviteAgentModal.tsx
msgid "Dear {agentName},"
msgstr "亲爱的 {agentName}："

#: src/components/DecommissionAgentModal.tsx
msgid "Decommission {agentName}"
msgstr "停用并删除 {agentName}"

#: src/components/AgentManager.tsx
#: src/components/ComputerDetailView.tsx
#: src/components/DecommissionAgentModal.tsx
msgid "Delete"
msgstr "删除"

#: src/components/DecommissionAgentModal.tsx
msgid "Delete {agentName}?"
msgstr "删除 {agentName}？"

#: src/components/ComputerDetailView.tsx
msgid "Delete {machineName}"
msgstr "删除 {machineName}"

#: src/components/DecommissionAgentModal.tsx
msgid "Delete <0>{agentName}</0> to revoke its credentials, disconnect it, and nudge <1>{hostedMachineLabel}</1> to remove the hosted runtime."
msgstr "删除 <0>{agentName}</0> 将撤销其凭据、断开连接，并通知 <1>{hostedMachineLabel}</1> 移除托管运行时。"

#: src/lib/capabilities.ts
msgid "Delete a channel"
msgstr "删除频道"

#: src/components/AgentLifecycleSection.tsx
#: src/components/DecommissionAgentModal.tsx
msgid "Delete agent"
msgstr "删除 Agent"

#: src/components/ComputerDetailView.tsx
#: src/components/DecommissionAgentModal.tsx
msgid "Delete Agent"
msgstr "删除 Agent"

#: src/components/AgentLifecycleSection.tsx
msgid "Delete agent…"
msgstr "删除 Agent…"

#: src/components/AgentManager.tsx
msgid "Delete channels"
msgstr "删除频道"

#: src/components/ComputerDetailView.tsx
msgid "Delete Computer"
msgstr "删除电脑"

#: src/components/DecommissionAgentModal.tsx
msgid "Delete hosted agent"
msgstr "删除托管 Agent"

#: src/components/ComputerDetailView.tsx
msgid "Delete Hosted Agent"
msgstr "删除托管 Agent"

#: src/components/DecommissionAgentModal.tsx
msgid "Delete hosted agent {agentName}"
msgstr "删除托管 Agent {agentName}"

#: src/components/DecommissionAgentModal.tsx
msgid "Delete hosted agent {agentName}?"
msgstr "删除托管 Agent {agentName}？"

#. placeholder {0}: agent.display_name
#: src/components/ComputerDetailView.tsx
msgid "Delete hosted agent <0>{0}</0>?"
msgstr "删除托管 Agent <0>{0}</0>？"

#: src/components/ComputerDetailView.tsx
msgid "Delete permanently"
msgstr "永久删除"

#: src/components/DecommissionAgentModal.tsx
msgid "Deleting Hosted Agent..."
msgstr "正在删除托管 Agent..."

#: src/components/ComputerDetailView.tsx
msgid "Deleting this computer removes its connection token, drops its bindings, and disconnects it from Borgee immediately."
msgstr "删除这台电脑将移除连接令牌和绑定，并立即断开其与 Borgee 的连接。"

#: src/components/ComputerDetailView.tsx
#: src/components/DecommissionAgentModal.tsx
msgid "Deleting..."
msgstr "正在删除..."

#: src/components/AgentDetailView.tsx
msgid "DESCRIPTION"
msgstr "描述"

#: src/components/AgentLifecycleSection.tsx
msgid "Disable"
msgstr "禁用"

#: src/components/AgentLifecycleSection.tsx
msgid "Disable agent"
msgstr "禁用 Agent"

#: src/lib/agent-state.ts
msgid "Disabled"
msgstr "已禁用"

#: src/components/AgentManager.tsx
msgid "Disabled: respond to every message"
msgstr "已关闭：响应所有消息"

#: src/components/AgentLifecycleSection.tsx
msgid "Disabling…"
msgstr "正在禁用…"

#: src/components/DecommissionAgentModal.tsx
msgid "Disconnect the Borgee remote channel"
msgstr "断开 Borgee 远程频道"

#: src/components/AgentDisabledBanner.tsx
msgid "Dismiss"
msgstr "关闭"

#: src/components/InviteAgentModal.tsx
msgid "Display Name"
msgstr "显示名称"

#: src/components/AgentDetailView.tsx
msgid "DISPLAY NAME"
msgstr "显示名称"

#: src/components/AgentManager.tsx
#: src/components/DecommissionAgentModal.tsx
#: src/components/InviteAgentModal.tsx
msgid "Done"
msgstr "完成"

#: src/components/AgentConnectResult.tsx
msgid "dsh warns"
msgstr "dsh 提示"

#: src/components/AgentManager.tsx
#: src/components/InviteAgentModal.tsx
msgid "e.g. Alice"
msgstr "例如 Alice"

#: src/components/AgentManager.tsx
msgid "e.g. Codex Builder"
msgstr "例如 Codex Builder"

#: src/components/AgentManager.tsx
msgid "e.g. Kagura"
msgstr "例如 Kagura"

#: src/components/AgentManager.tsx
msgid "e.g. Kosmos"
msgstr "例如 Kosmos"

#: src/components/AgentDisabledBanner.tsx
#: src/components/AgentLifecycleSection.tsx
#: src/hooks/useAgentLifecycle.ts
msgid "Enable"
msgstr "启用"

#. placeholder {0}: agent.display_name
#: src/components/RuntimeCard.tsx
msgid "Enable {0} before starting its runtime — a disabled agent cannot hold a plugin connection."
msgstr "请先启用 {0} 再启动运行时；已禁用的 Agent 无法保持插件连接。"

#: src/components/AgentLifecycleSection.tsx
msgid "Enable agent"
msgstr "启用 Agent"

#: src/components/AgentDetailView.tsx
msgid "Enable the agent before rotating its key"
msgstr "请先启用 Agent，再轮换密钥"

#: src/lib/openclaw-onboarding.ts
msgid "Enable the plugin and token-usage telemetry (skip if already enabled)"
msgstr "启用插件和 token 用量遥测（已启用则跳过）"

#: src/components/ManagedAgentProvisioningStatus.tsx
msgid "Enable this Agent to resume setup on its computer."
msgstr "启用此 Agent 以继续在其电脑上进行设置。"

#: src/components/AgentConfigPanel.tsx
msgid "Enabled"
msgstr "已启用"

#: src/components/AgentManager.tsx
msgid "Enabled: respond only when mentioned"
msgstr "已开启：仅在被提及时响应"

#: src/components/AgentDisabledBanner.tsx
#: src/components/AgentLifecycleSection.tsx
msgid "Enabling…"
msgstr "正在启用…"

#: src/lib/openclaw-onboarding.ts
msgid "Ensure Borgee tool access while preserving your existing tool profile or allow-list"
msgstr "确保 Borgee 工具可用，同时保留现有工具配置或允许列表"

#: src/components/RuntimeCard.tsx
msgid "Error"
msgstr "错误"

#: src/lib/agent-state.ts
msgid "Error ({reasonText})"
msgstr "故障（{reasonText}）"

#: src/components/ComputerDetailView.tsx
msgid "Every hosted agent on this computer will be deleted too."
msgstr "这台电脑上的所有托管 Agent 也将被删除。"

#: src/lib/openclaw-onboarding.ts
msgid "Example additive configuration:"
msgstr "追加配置示例："

#: src/components/ComputerDetailView.tsx
msgid "Existing repository directory"
msgstr "已有仓库目录"

#: src/components/ComputerDetailView.tsx
msgid "EXPOSED DIRECTORIES"
msgstr "共享目录"

#: src/components/ComputerDetailView.tsx
msgid "Exposed directories are available only while this computer is online."
msgstr "共享目录仅在这台电脑在线时可用。"

#: src/components/AgentDetailView.tsx
#: src/components/AgentManager.tsx
#: src/components/ManagedAgentProvisioningStatus.tsx
msgid "Failed"
msgstr "失败"

#: src/components/DecommissionAgentModal.tsx
msgid "Failed to delete"
msgstr "删除失败"

#: src/components/AgentManager.tsx
msgid "Failed to save projection strategy"
msgstr "无法保存投影策略"

#. placeholder {0}: i18n.number(failedAgents.length)
#: src/components/FailureCenter.tsx
msgid "Failure center ({0})"
msgstr "故障中心（{0}）"

#: src/components/FailurePopover.tsx
msgid "Failure details"
msgstr "故障详情"

#: src/components/AgentDetailView.tsx
msgid "file-brief: stable Borgee projection is written to a provider-visible CLAUDE.md brief."
msgstr "file-brief：将稳定的 Borgee 投影写入提供方可见的 CLAUDE.md 摘要。"

#: src/components/InviteAgentModal.tsx
msgid "From: {ownerName}"
msgstr "来自：{ownerName}"

#. placeholder {0}: i18n.number(selected.size)
#: src/components/BundleSelector.tsx
msgid "Grant {0} capabilities"
msgstr "授予 {0} 项能力"

#: src/components/ComputerDetailView.tsx
msgid "Hide Token"
msgstr "隐藏令牌"

#: src/components/AgentDetailView.tsx
msgid "Hosted"
msgstr "托管"

#. placeholder {0}: hostedAgents.length
#: src/components/ComputerDetailView.tsx
msgid "HOSTED AGENTS ({0})"
msgstr "托管 Agent（{0}）"

#: src/components/AgentDetailView.tsx
msgid "HOSTED BY COMPUTER"
msgstr "托管电脑"

#: src/components/AgentDetailView.tsx
msgid "HOSTED RUNTIME"
msgstr "托管运行时"

#: src/components/ComputerDetailView.tsx
msgid "Hosted-agent cascade acknowledged"
msgstr "已确认连带删除托管 Agent"

#: src/components/DecommissionAgentModal.tsx
msgid "How is {agentName} connected?"
msgstr "{agentName} 通过什么方式连接？"

#: src/components/AgentManager.tsx
msgid "How would you like to add an agent to this Project?"
msgstr "你想如何向此项目添加 Agent？"

#: src/components/DecommissionAgentModal.tsx
msgid "I'll do this later"
msgstr "稍后处理"

#. placeholder {0}: node.id
#: src/components/ComputerDetailView.tsx
msgid "ID: {0}"
msgstr "ID：{0}"

#: src/lib/agent-state.ts
msgid "Idle"
msgstr "空闲"

#: src/components/DecommissionAgentModal.tsx
msgid "If you can't reach Kosmos now, you can skip this step — the agent will be disconnected automatically after deletion."
msgstr "如果现在无法操作 Kosmos，可以跳过此步骤；删除后 Agent 将自动断开连接。"

#: src/components/DecommissionAgentModal.tsx
msgid "If you can't stop DSH Web, you can skip this step — the agent will be disconnected automatically after deletion."
msgstr "如果无法停止 DSH Web，可以跳过此步骤；删除后 Agent 将自动断开连接。"

#: src/components/DecommissionAgentModal.tsx
msgid "If you can't stop the process, you can skip this step — the agent will be disconnected automatically after deletion."
msgstr "如果无法停止该进程，可以跳过此步骤；删除后 Agent 将自动断开连接。"

#: src/components/DecommissionAgentModal.tsx
msgid "If you skip this step, the plugin will fail to connect after deletion."
msgstr "如果跳过此步骤，删除后插件将无法连接。"

#: src/components/AgentConnectResult.tsx
msgid "In Kosmos Desktop"
msgstr "在 Kosmos Desktop 中"

#: src/components/DecommissionAgentModal.tsx
msgid "In Kosmos Desktop, open Settings → Remote Channel → Borgee and click Disconnect:"
msgstr "在 Kosmos Desktop 中打开 Settings → Remote Channel → Borgee，然后点击 Disconnect："

#: src/lib/openclaw-onboarding.ts
msgid "Inspect your current tools configuration, then merge message, borgee_task and borgee_list_zones into its additional allow-list."
msgstr "检查当前工具配置，然后将 message、borgee_task 和 borgee_list_zones 合并到其额外允许列表中。"

#: src/lib/openclaw-onboarding.ts
msgid "Inspect your existing bindings and merge this entry; do not replace the bindings array."
msgstr "检查现有绑定并合并此项；不要替换整个 bindings 数组。"

#: src/components/ComputerDetailView.tsx
msgid "INSTALL COMMAND"
msgstr "安装命令"

#: src/lib/openclaw-onboarding.ts
msgid "Install the Borgee plugin (skip if already installed)"
msgstr "安装 Borgee 插件（已安装则跳过）"

#: src/components/AgentConnectResult.tsx
msgid "Install the connector into your DSH Web profile"
msgstr "将连接器安装到 DSH Web 配置中"

#: src/components/ManagedAgentProvisioningStatus.tsx
msgid "Installing"
msgstr "正在安装"

#: src/components/ManagedAgentProvisioningStatus.tsx
msgid "Installing the agent runtime"
msgstr "正在安装 Agent 运行时"

#: src/lib/agent-state.ts
msgid "Invalid API key"
msgstr "API 密钥无效"

#: src/components/InviteAgentModal.tsx
msgid "Invitation"
msgstr "邀请"

#: src/lib/capabilities.ts
msgid "Invite people into a channel"
msgstr "邀请用户"

#: src/components/ManagedAgentProvisioningStatus.tsx
msgid "Last observed report"
msgstr "最后观测到的报告"

#. placeholder {0}: i18n._(setupStateLabels[setup.state])
#: src/components/ManagedAgentProvisioningStatus.tsx
msgid "Last observed setup: {0}."
msgstr "最后观测到的设置：{0}。"

#: src/components/ManagedAgentProvisioningStatus.tsx
msgid "Last report"
msgstr "最近报告"

#: src/components/ComputerDetailView.tsx
msgid "LAST SEEN"
msgstr "最近在线"

#. placeholder {0}: AGENT_PROVIDER_LABELS[connectProvider]
#: src/components/AgentManager.tsx
msgid "Last selected: {0}<0>(Saved on this device; does not indicate the current connection)</0>"
msgstr "上次选择：{0}<0>（保存在此设备上，不表示当前连接状态）</0>"

#: src/components/AgentLifecycleSection.tsx
msgid "LIFECYCLE"
msgstr "生命周期"

#: src/components/PermissionsView.tsx
msgid "Loading"
msgstr "正在加载"

#: src/components/AgentManager.tsx
msgid "Loading connected computers…"
msgstr "正在加载已连接的电脑…"

#: src/components/ComputerDetailView.tsx
msgid "Loading hosted agents..."
msgstr "正在加载托管 Agent..."

#: src/components/ComputerDetailView.tsx
msgid "Loading mappings..."
msgstr "正在加载映射..."

#: src/components/AgentConfigPanel.tsx
#: src/components/AgentDetailView.tsx
#: src/components/AgentManager.tsx
#: src/components/AgentSidebar.tsx
#: src/components/ComputerDetailView.tsx
#: src/components/ComputerSidebar.tsx
#: src/components/DecommissionAgentModal.tsx
msgid "Loading..."
msgstr "正在加载..."

#: src/components/AgentDetailView.tsx
msgid "Loading…"
msgstr "正在加载…"

#: src/components/ComputerDetailView.tsx
msgid "MACHINE NAME"
msgstr "电脑名称"

#: src/lib/capabilities.ts
msgid "Make a channel public or private"
msgstr "调整频道可见性"

#: src/components/AgentManager.tsx
msgid "Manage"
msgstr "管理"

#: src/components/AgentManager.tsx
msgid "Manage channel members"
msgstr "管理频道成员"

#: src/components/AgentManager.tsx
msgid "Manage channel visibility"
msgstr "管理频道可见性"

#. placeholder {0}: hostedPlacement?.provider === 'claude' ? 'Claude Code' : hostedPlacement?.provider === 'codex' ? 'Codex' : 'GitHub Copilot'
#: src/components/AgentDetailView.tsx
msgid "Managed by this computer through {0}."
msgstr "由这台电脑通过 {0} 管理。"

#: src/components/AgentConfigPanel.tsx
msgid "Memory reference"
msgstr "记忆引用"

#: src/lib/capabilities.ts
msgid "Mention other accounts"
msgstr "提及用户"

#: src/components/AgentManager.tsx
msgid "Mention settings"
msgstr "提及设置"

#: src/components/AgentDetailView.tsx
msgid "message-only: ordinary turns pass through mostly the raw user message."
msgstr "message-only：普通轮次主要传递原始用户消息。"

#: src/components/AgentConfigPanel.tsx
msgid "Model"
msgstr "模型"

#: src/components/AgentManager.tsx
#: src/components/AgentSidebar.tsx
msgid "My Agents"
msgstr "我的 Agent"

#: src/components/ComputerSidebar.tsx
msgid "My Computers"
msgstr "我的电脑"

#: src/components/AgentConfigPanel.tsx
msgid "Name"
msgstr "名称"

#: src/components/AgentManager.tsx
msgid "Name your agent"
msgstr "为 Agent 命名"

#: src/lib/agent-state.ts
msgid "Network unreachable"
msgstr "网络不可达"

#: src/components/ComputerDetailView.tsx
msgid "Never"
msgstr "从未"

#: src/components/AgentDetailView.tsx
msgid "New API Key copied"
msgstr "新 API 密钥已复制"

#: src/components/DecommissionAgentModal.tsx
msgid "Next"
msgstr "下一步"

#: src/components/AgentSidebar.tsx
msgid "No agents yet"
msgstr "暂无 Agent"

#: src/components/AgentManager.tsx
msgid "No agents yet. Create one to get started."
msgstr "暂无 Agent。创建一个即可开始。"

#: src/components/DecommissionAgentModal.tsx
msgid "No channels to remove from."
msgstr "没有需要移除的频道。"

#: src/components/ComputerSidebar.tsx
msgid "No computers yet"
msgstr "暂无电脑"

#: src/components/AgentManager.tsx
msgid "No connected computers"
msgstr "没有已连接的电脑"

#: src/components/AgentDetailView.tsx
msgid "No description"
msgstr "暂无描述"

#: src/components/ComputerDetailView.tsx
msgid "No hosted agents are currently bound to this computer."
msgstr "当前没有托管 Agent 绑定到这台电脑。"

#: src/components/ComputerDetailView.tsx
msgid "No hosted agents yet."
msgstr "暂无托管 Agent。"

#: src/components/PermissionsView.tsx
msgid "No permissions granted"
msgstr "暂无授权"

#: src/components/AgentManager.tsx
msgid "No Project"
msgstr "不选择项目"

#: src/components/ManagedAgentProvisioningStatus.tsx
msgid "No recent setup update from this computer"
msgstr "这台电脑近期没有上报设置进度"

#: src/components/ComputerDetailView.tsx
msgid "No repository mappings yet."
msgstr "暂无仓库映射。"

#: src/components/ManagedAgentProvisioningStatus.tsx
msgid "Node.js is not available on this computer. Install Node.js 22 or later."
msgstr "这台电脑上没有 Node.js。请安装 Node.js 22 或更高版本。"

#: src/components/ManagedAgentProvisioningStatus.tsx
msgid "Not managed by a computer"
msgstr "未由电脑托管"

#: src/components/RuntimeCard.tsx
msgid "Not started"
msgstr "未启动"

#: src/components/ManagedAgentProvisioningStatus.tsx
msgid "npm is not available on this computer. Install npm with Node.js."
msgstr "这台电脑上没有 npm。请随 Node.js 一起安装 npm。"

#: src/components/ComputerDetailView.tsx
#: src/components/ManagedAgentProvisioningStatus.tsx
#: src/lib/agent-state.ts
msgid "Offline"
msgstr "离线"

#: src/components/AgentDetailView.tsx
msgid "One setting per top-level channel. Task threads inherit from the parent channel."
msgstr "每个顶层频道使用一项设置。任务讨论串继承父频道的设置。"

#: src/components/AgentManager.tsx
msgid "One setting per top-level channel. Task threads inherit the parent channel strategy."
msgstr "每个顶层频道使用一项设置。任务讨论串继承父频道的策略。"

#: src/components/ComputerDetailView.tsx
#: src/lib/agent-state.ts
msgid "Online"
msgstr "在线"

#: src/components/AgentManager.tsx
msgid "Only computers that are connected right now can host a managed agent."
msgstr "只有当前已连接的电脑才能托管 Agent。"

#: src/components/AgentDetailView.tsx
msgid "Only its owner can see this agent."
msgstr "只有所有者可以查看此 Agent。"

#: src/components/AgentManager.tsx
msgid "Only the Agent owner can add it to a Project."
msgstr "只有 Agent 所有者才能将其添加到项目。"

#: src/components/ManagedAgentProvisioningStatus.tsx
msgid "Only you, the Agent owner, can see setup details."
msgstr "只有你作为 Agent 所有者才能看到设置详情。"

#: src/lib/capabilities.ts
msgid "Open a channel and read its contents"
msgstr "查看频道"

#: src/components/ManagedAgentProvisioningStatus.tsx
msgid "Open chat"
msgstr "打开聊天"

#: src/components/AgentDetailView.tsx
msgid "Open computer page"
msgstr "打开电脑页面"

#: src/components/AgentConnectResult.tsx
msgid "Open Settings → Remote Channel → Borgee, then click Disconnect."
msgstr "打开 Settings → Remote Channel → Borgee，然后点击 Disconnect。"

#: src/components/AgentConnectResult.tsx
msgid "Open Settings → Remote Channel → Borgee, then select the local Kosmos agent that should answer Borgee messages."
msgstr "打开 Settings → Remote Channel → Borgee，然后选择应该响应 Borgee 消息的本地 Kosmos Agent。"

#: src/components/ManagedAgentProvisioningStatus.tsx
msgid "Pending assignment"
msgstr "等待分配"

#: src/components/AgentManager.tsx
msgid "Permissions"
msgstr "权限"

#: src/lib/openclaw-onboarding.ts
msgid "Pick a simple account slug (letters, numbers, - or _, for example \"borgee\")."
msgstr "选择一个简单的账号标识（字母、数字、- 或 _，例如 \"borgee\"）。"

#: src/lib/capabilities.ts
msgid "Post messages in a channel"
msgstr "在频道发消息"

#: src/lib/openclaw-onboarding.ts
msgid "Preserve any existing Borgee accounts and channel policy."
msgstr "保留已有的 Borgee 账号和频道策略。"

#: src/components/AgentConnectResult.tsx
msgid "Press Ctrl+C in the terminal running agents-host"
msgstr "在运行 agents-host 的终端中按 Ctrl+C"

#: src/components/AgentConnectResult.tsx
msgid "Press Ctrl+C in the terminal running borgee-praestoclaw"
msgstr "在运行 borgee-praestoclaw 的终端中按 Ctrl+C"

#: src/components/AgentConnectResult.tsx
msgid "Press Ctrl+C in the terminal running dsh web"
msgstr "在运行 dsh web 的终端中按 Ctrl+C"

#: src/components/AgentConnectResult.tsx
msgid "Press Ctrl+C in the terminal running hermes server"
msgstr "在运行 hermes server 的终端中按 Ctrl+C"

#: src/components/AgentDetailView.tsx
msgid "Profile"
msgstr "资料"

#: src/components/AgentManager.tsx
msgid "Project (optional)"
msgstr "项目（可选）"

#: src/components/AgentManager.tsx
msgid "Projection Strategy"
msgstr "投影策略"

#: src/components/AgentDetailView.tsx
msgid "PROJECTION STRATEGY"
msgstr "投影策略"

#: src/components/AgentDetailView.tsx
msgid "Projection strategy descriptions"
msgstr "投影策略说明"

#. placeholder {0}: channel.name
#: src/components/AgentDetailView.tsx
#: src/components/AgentManager.tsx
msgid "Projection strategy for {0}"
msgstr "{0} 的投影策略"

#: src/components/AgentDetailView.tsx
#: src/components/AgentManager.tsx
msgid "Projection strategy saved"
msgstr "投影策略已保存"

#: src/components/AgentConfigPanel.tsx
msgid "Prompt"
msgstr "提示词"

#: src/components/AgentLifecycleSection.tsx
msgid "Puts {agentName} back to work in the channels it already belongs to. Nothing else changes."
msgstr "让 {agentName} 在已加入的频道中恢复工作。其他设置保持不变。"

#: src/lib/agent-state.ts
msgid "Quota exceeded"
msgstr "已超出配额"

#: src/lib/capabilities.ts
msgid "Read direct messages"
msgstr "查看私信"

#: src/lib/capabilities.ts
msgid "Read message history"
msgstr "查看消息历史"

#: src/components/DecommissionAgentModal.tsx
msgid "Ready to delete {agentName} and stop hosting on {hostedMachineLabel}."
msgstr "准备删除 {agentName}，并停止在 {hostedMachineLabel} 上托管。"

#: src/components/ManagedAgentProvisioningStatus.tsx
msgid "Reason"
msgstr "原因"

#: src/components/FailurePopover.tsx
msgid "Reconnect"
msgstr "重连"

#: src/components/ManagedAgentProvisioningStatus.tsx
msgid "Refresh status"
msgstr "刷新状态"

#: src/components/DecommissionAgentModal.tsx
msgid "Refreshing hosted agents on {hostedMachineLabel}..."
msgstr "正在刷新 {hostedMachineLabel} 上的托管 Agent..."

#: src/components/DecommissionAgentModal.tsx
msgid "Refreshing hosted status"
msgstr "正在刷新托管状态"

#: src/components/DecommissionAgentModal.tsx
msgid "Refreshing hosted status..."
msgstr "正在刷新托管状态..."

#: src/components/DecommissionAgentModal.tsx
msgid "Refreshing..."
msgstr "正在刷新..."

#: src/components/ComputerDetailView.tsx
msgid "Regenerate Connection Token"
msgstr "重新生成连接令牌"

#: src/components/ComputerDetailView.tsx
msgid "Regenerate Token"
msgstr "重新生成令牌"

#: src/components/ComputerDetailView.tsx
msgid "Remote Helper could not complete the repository mapping request. Check the helper logs, then retry."
msgstr "Remote Helper 无法完成仓库映射请求。请检查 Helper 日志后重试。"

#: src/components/DecommissionAgentModal.tsx
msgid "Remove from channels"
msgstr "从频道中移除"

#: src/components/ComputerDetailView.tsx
msgid "Remove Mapping"
msgstr "删除映射"

#: src/components/DecommissionAgentModal.tsx
msgid "Remove the Borgee plugin"
msgstr "移除 Borgee 插件"

#: src/components/DecommissionAgentModal.tsx
msgid "Remove the Borgee plugin from {name}:"
msgstr "从 {name} 中移除 Borgee 插件："

#: src/components/DecommissionAgentModal.tsx
msgid "Removed"
msgstr "已移除"

#. placeholder {0}: mapping.repository
#: src/components/ComputerDetailView.tsx
msgid "Removed {0}. Local files were not deleted."
msgstr "已移除 {0}。本地文件未被删除。"

#: src/components/DecommissionAgentModal.tsx
msgid "Removed from all channels"
msgstr "已从所有频道移除"

#: src/components/AgentLifecycleSection.tsx
msgid "Removes {agentName} from every channel, disconnects it, and deletes the account for good. Its messages stay but lose their author. There is no undo."
msgstr "从所有频道移除 {agentName}，断开连接并永久删除账号。其消息会保留，但不再显示作者。此操作无法撤销。"

#: src/components/DecommissionAgentModal.tsx
msgid "Removing…"
msgstr "正在移除…"

#: src/components/FailurePopover.tsx
msgid "Replace API key"
msgstr "更换 API 密钥"

#: src/components/AgentConnectResult.tsx
msgid "Replace the cwd placeholder below before you run this"
msgstr "运行前请替换下面的 cwd 占位符"

#: src/lib/openclaw-onboarding.ts
msgid "Replace YOUR_AGENT_ID and YOUR_ACCOUNT_SLUG:"
msgstr "替换 YOUR_AGENT_ID 和 YOUR_ACCOUNT_SLUG："

#: src/components/ComputerDetailView.tsx
msgid "Repository identity"
msgstr "仓库标识"

#: src/components/ComputerDetailView.tsx
msgid "REPOSITORY MAPPINGS"
msgstr "仓库映射"

#: src/components/ComputerDetailView.tsx
msgid "Repository must identify a github.com owner/repository."
msgstr "仓库必须标识 github.com 上的 owner/repository。"

#: src/components/ComputerDetailView.tsx
msgid "Resolve"
msgstr "解析"

#. placeholder {0}: checked.repository
#. placeholder {1}: checked.path
#: src/components/ComputerDetailView.tsx
msgid "Resolved {0} to {1}."
msgstr "已将 {0} 解析为 {1}。"

#: src/components/AgentManager.tsx
msgid "Respond only when mentioned"
msgstr "仅在被提及时响应"

#: src/components/AgentConnectResult.tsx
msgid "Restart DSH Web"
msgstr "重启 DSH Web"

#: src/lib/openclaw-onboarding.ts
msgid "Restart to connect"
msgstr "重启以连接"

#: src/components/AgentManager.tsx
msgid "Retry adding the agent to the Project before its selected channels."
msgstr "请先重试将 Agent 添加到项目，再添加到所选频道。"

#: src/components/AgentManager.tsx
msgid "Retry configuration"
msgstr "重试配置"

#: src/components/AgentManager.tsx
msgid "Retry membership"
msgstr "重试成员关系更新"

#: src/components/AgentManager.tsx
msgid "Retry the channels that were not added."
msgstr "重试添加未成功加入的频道。"

#: src/components/AgentManager.tsx
msgid "Retrying..."
msgstr "正在重试..."

#: src/components/AgentConnectResult.tsx
msgid "Return to Borgee and wait for {agentName} to become online."
msgstr "返回 Borgee 并等待 {agentName} 上线。"

#: src/components/ComputerDetailView.tsx
msgid "Review connection impact"
msgstr "确认连接影响"

#: src/components/ComputerDetailView.tsx
msgid "Review hosted-agent impact"
msgstr "确认托管 Agent 影响"

#: src/components/ManagedAgentProvisioningStatus.tsx
msgid "Review this Agent’s computer configuration."
msgstr "请检查此 Agent 的电脑配置。"

#: src/components/AgentDetailView.tsx
msgid "Rotate"
msgstr "轮换"

#: src/components/AgentManager.tsx
msgid "Rotate API Key"
msgstr "轮换 API 密钥"

#: src/components/AgentManager.tsx
msgid "Run these commands on the machine where <0>{createdName}</0> will run"
msgstr "在将运行 <0>{createdName}</0> 的电脑上执行这些命令"

#: src/components/ComputerDetailView.tsx
msgid "Run this on the target computer (macOS or Linux). Replace the quoted <0>'/path/to/dir'</0> value with at least one directory to expose."
msgstr "在目标电脑（macOS 或 Linux）上运行此命令。将引号中的 <0>'/path/to/dir'</0> 替换为至少一个要共享的目录。"

#: src/components/AgentConnectResult.tsx
msgid "Run this once — if the file already lists borgee-dsh, edit that entry instead"
msgstr "仅运行一次；如果文件已列出 borgee-dsh，请编辑已有条目"

#: src/components/RuntimeCard.tsx
msgid "Running"
msgstr "运行中"

#: src/components/AgentManager.tsx
#: src/components/RuntimeCard.tsx
msgid "Runtime"
msgstr "运行时"

#: src/lib/agent-state.ts
msgid "Runtime crashed"
msgstr "运行时崩溃"

#: src/components/ManagedAgentProvisioningStatus.tsx
msgid "Runtime credentials rejected"
msgstr "运行时凭据被拒绝"

#: src/components/ManagedAgentProvisioningStatus.tsx
msgid "Runtime details"
msgstr "运行时详情"

#: src/components/ManagedAgentProvisioningStatus.tsx
msgid "Runtime installation took too long. Check the computer’s internet connection."
msgstr "运行时安装超时。请检查电脑的网络连接。"

#: src/components/ManagedAgentProvisioningStatus.tsx
msgid "Runtime needs attention"
msgstr "运行时需要处理"

#: src/components/ManagedAgentProvisioningStatus.tsx
msgid "Runtime network unavailable"
msgstr "运行时网络不可用"

#: src/components/ManagedAgentProvisioningStatus.tsx
msgid "Runtime quota exhausted"
msgstr "运行时配额已用完"

#: src/components/ManagedAgentProvisioningStatus.tsx
msgid "Runtime response timed out"
msgstr "运行时响应超时"

#: src/components/ManagedAgentProvisioningStatus.tsx
msgid "Runtime status"
msgstr "运行时状态"

#: src/components/ManagedAgentProvisioningStatus.tsx
msgid "Runtime stopped unexpectedly"
msgstr "运行时意外停止"

#: src/lib/agent-state.ts
msgid "Runtime timed out"
msgstr "运行时超时"

#: src/components/AgentConfigPanel.tsx
#: src/components/AgentDetailView.tsx
#: src/components/AgentManager.tsx
msgid "Save"
msgstr "保存"

#: src/components/AgentConfigPanel.tsx
#: src/components/AgentDetailView.tsx
#: src/components/AgentManager.tsx
msgid "Saving..."
msgstr "正在保存..."

#: src/components/AgentManager.tsx
msgid "Saving…"
msgstr "正在保存…"

#: src/components/AgentConfigPanel.tsx
msgid "Schema version"
msgstr "配置结构版本"

#: src/components/AgentManager.tsx
msgid "Select channel..."
msgstr "选择频道..."

#: src/lib/capabilities.ts
msgid "Send direct messages"
msgstr "发送私信"

#: src/components/AgentManager.tsx
#: src/lib/capabilities.ts
msgid "Send messages"
msgstr "发送消息"

#: src/components/AgentDetailView.tsx
msgid "session-brief: stable Borgee projection lives mainly in the Claude session brief."
msgstr "session-brief：稳定的 Borgee 投影主要保存在 Claude 会话摘要中。"

#: src/components/ManagedAgentProvisioningStatus.tsx
msgid "SETUP"
msgstr "设置"

#: src/components/ManagedAgentProvisioningStatus.tsx
msgid "Setup accepted by your computer"
msgstr "电脑已接受设置"

#: src/components/ManagedAgentProvisioningStatus.tsx
msgid "Setup details"
msgstr "设置详情"

#: src/components/ManagedAgentProvisioningStatus.tsx
msgid "Setup is taking longer than expected"
msgstr "设置耗时超出预期"

#: src/components/ManagedAgentProvisioningStatus.tsx
msgid "Setup status"
msgstr "设置状态"

#: src/components/ManagedAgentProvisioningStatus.tsx
msgid "Setup status cannot be refreshed. Updates resume when this browser reconnects."
msgstr "无法刷新设置状态。浏览器重新连接后将恢复更新。"

#: src/components/ManagedAgentProvisioningStatus.tsx
msgid "Setup status is unavailable. Keep the computer awake and check that Borgee’s helper is running."
msgstr "设置状态不可用。请保持电脑唤醒，并检查 Borgee Helper 是否正在运行。"

#: src/components/ManagedAgentProvisioningStatus.tsx
msgid "Setup status unavailable"
msgstr "设置状态不可用"

#: src/components/AgentDetailView.tsx
msgid "Show instructions anyway"
msgstr "仍然显示说明"

#: src/components/ComputerDetailView.tsx
msgid "Show Token"
msgstr "显示令牌"

#: src/components/DecommissionAgentModal.tsx
msgid "Skip, delete anyway"
msgstr "跳过，继续删除"

#: src/components/AgentManager.tsx
#: src/components/DecommissionAgentModal.tsx
msgid "Skip, I'll do this later"
msgstr "跳过，稍后处理"

#: src/components/AgentManager.tsx
#: src/components/InviteAgentModal.tsx
msgid "Someone"
msgstr "某人"

#: src/components/DecommissionAgentModal.tsx
#: src/components/RuntimeCard.tsx
msgid "Start"
msgstr "启动"

#: src/components/ComputerDetailView.tsx
msgid "Start Remote Helper on this computer to manage repository mappings."
msgstr "在这台电脑上启动 Remote Helper 以管理仓库映射。"

#: src/components/RuntimeCard.tsx
msgid "Starting…"
msgstr "正在启动…"

#: src/components/AgentConnectResult.tsx
msgid "Step 1: Disable the Borgee plugin"
msgstr "第 1 步：禁用 Borgee 插件"

#: src/components/AgentConnectResult.tsx
msgid "Step 1: Install Borgee agents-host"
msgstr "第 1 步：安装 Borgee agents-host"

#: src/components/AgentConnectResult.tsx
msgid "Step 1: Install Claude Code (skip if already installed)"
msgstr "第 1 步：安装 Claude Code（已安装则跳过）"

#: src/components/AgentConnectResult.tsx
msgid "Step 1: Install GitHub Copilot (skip if already installed)"
msgstr "第 1 步：安装 GitHub Copilot（已安装则跳过）"

#: src/components/AgentConnectResult.tsx
msgid "Step 1: Install Hermes Agent"
msgstr "第 1 步：安装 Hermes Agent"

#: src/components/AgentConnectResult.tsx
msgid "Step 1: Install Hermes Agent (PowerShell)"
msgstr "第 1 步：安装 Hermes Agent（PowerShell）"

#: src/components/AgentConnectResult.tsx
msgid "Step 1: Install OpenClaw (skip if already installed)"
msgstr "第 1 步：安装 OpenClaw（已安装则跳过）"

#: src/components/AgentConnectResult.tsx
msgid "Step 1: Install PraestoClaw"
msgstr "第 1 步：安装 PraestoClaw"

#: src/components/AgentConnectResult.tsx
msgid "Step 1: Open Kosmos Desktop"
msgstr "第 1 步：打开 Kosmos Desktop"

#: src/components/AgentConnectResult.tsx
msgid "Step 2: Connect this agent"
msgstr "第 2 步：连接此 Agent"

#: src/components/AgentConnectResult.tsx
msgid "Step 2: Copy and paste this Server URL"
msgstr "第 2 步：复制并粘贴此服务器 URL"

#: src/components/AgentConnectResult.tsx
msgid "Step 2: Install Borgee agents-host"
msgstr "第 2 步：安装 Borgee agents-host"

#: src/components/AgentConnectResult.tsx
msgid "Step 2: Install Borgee plugin (requires Python 3.11+)"
msgstr "第 2 步：安装 Borgee 插件（需要 Python 3.11 或更高版本）"

#: src/components/AgentConnectResult.tsx
msgid "Step 2: Install the Borgee bridge plugin"
msgstr "第 2 步：安装 Borgee 桥接插件"

#: src/components/AgentConnectResult.tsx
msgid "Step 2: Install the Borgee plugin"
msgstr "第 2 步：安装 Borgee 插件"

#: src/components/AgentConnectResult.tsx
msgid "Step 2: Restart the gateway"
msgstr "第 2 步：重启网关"

#: src/components/AgentConnectResult.tsx
msgid "Step 3: Configure PraestoClaw API key for the bridge"
msgstr "第 3 步：为桥接配置 PraestoClaw API 密钥"

#: src/components/AgentConnectResult.tsx
msgid "Step 3: Configure your account"
msgstr "第 3 步：配置账号"

#: src/components/AgentConnectResult.tsx
msgid "Step 3: Connect this agent"
msgstr "第 3 步：连接此 Agent"

#: src/components/AgentConnectResult.tsx
msgid "Step 3: Copy and paste this API key"
msgstr "第 3 步：复制并粘贴此 API 密钥"

#: src/components/AgentConnectResult.tsx
msgid "Step 3: Setup Borgee platform config"
msgstr "第 3 步：配置 Borgee 平台"

#: src/components/AgentConnectResult.tsx
msgid "Step 4: Click Connect"
msgstr "第 4 步：点击 Connect"

#: src/components/AgentConnectResult.tsx
msgid "Step 4: Enable token-usage telemetry and restart"
msgstr "第 4 步：启用 token 用量遥测并重启"

#: src/components/AgentConnectResult.tsx
msgid "Step 4: Restart PraestoClaw to load the new key"
msgstr "第 4 步：重启 PraestoClaw 以加载新密钥"

#: src/components/AgentConnectResult.tsx
msgid "Step 4: Start Hermes"
msgstr "第 4 步：启动 Hermes"

#: src/components/AgentConnectResult.tsx
msgid "Step 5: Connect this agent (open a new terminal)"
msgstr "第 5 步：连接此 Agent（打开新终端）"

#: src/components/RuntimeCard.tsx
msgid "Stop"
msgstr "停止"

#: src/components/DecommissionAgentModal.tsx
msgid "Stop {name} on your machine:"
msgstr "停止电脑上的 {name}："

#: src/components/AgentConnectResult.tsx
msgid "Stop agents-host"
msgstr "停止 agents-host"

#: src/components/AgentConnectResult.tsx
#: src/components/DecommissionAgentModal.tsx
msgid "Stop DSH Web"
msgstr "停止 DSH Web"

#: src/components/DecommissionAgentModal.tsx
msgid "Stop the agent process"
msgstr "停止 Agent 进程"

#: src/components/DecommissionAgentModal.tsx
msgid "Stop the borgee-hermes-plugin on your machine:"
msgstr "停止电脑上的 borgee-hermes-plugin："

#: src/components/AgentConnectResult.tsx
msgid "Stop the borgee-praestoclaw bridge"
msgstr "停止 borgee-praestoclaw 桥接进程"

#: src/components/DecommissionAgentModal.tsx
msgid "Stop the bridge process"
msgstr "停止桥接进程"

#: src/components/DecommissionAgentModal.tsx
msgid "Stop the DSH Web process that hosts the Borgee connector:"
msgstr "停止托管 Borgee 连接器的 DSH Web 进程："

#: src/components/AgentConnectResult.tsx
msgid "Stop the Hermes server"
msgstr "停止 Hermes 服务器"

#: src/components/AgentConnectResult.tsx
msgid "Stop the running dsh web process with Ctrl+C, then run:"
msgstr "按 Ctrl+C 停止正在运行的 dsh web 进程，然后运行："

#: src/components/RuntimeCard.tsx
msgid "Stopped"
msgstr "已停止"

#: src/components/RuntimeCard.tsx
msgid "Stopping…"
msgstr "正在停止…"

#: src/components/AgentLifecycleSection.tsx
msgid "Stops {agentName} receiving messages. It keeps its channels, its history, and its key; one click brings it back."
msgstr "停止 {agentName} 接收消息。它的频道、历史和密钥都会保留，点击即可恢复。"

#: src/components/AgentConnectResult.tsx
msgid "That warning is expected: the connector is configured through the patch layer below"
msgstr "此警告是预期行为：连接器通过下方补丁层配置"

#: src/components/ManagedAgentProvisioningStatus.tsx
msgid "The active connection does not confirm that the new settings were applied."
msgstr "当前连接不表示新设置已经应用。"

#: src/lib/agent-failure-labels.ts
msgid "The API key is invalid. Enter a new one."
msgstr "API 密钥无效，请输入新密钥。"

#. placeholder {0}: status.exposed_dirs.join(', ')
#: src/components/ComputerDetailView.tsx
msgid "The checkout must live under one of this computer's exposed directories: {0}."
msgstr "仓库必须位于这台电脑的某个共享目录中：{0}。"

#: src/components/ManagedAgentProvisioningStatus.tsx
msgid "The computer could not apply the saved Agent configuration. Check the helper logs on this computer."
msgstr "电脑无法应用已保存的 Agent 配置。请检查这台电脑上的 Helper 日志。"

#: src/components/ManagedAgentProvisioningStatus.tsx
msgid "The computer could not check its Node.js installation. Check that Node.js runs correctly."
msgstr "电脑无法检查其 Node.js 安装。请确认 Node.js 能正常运行。"

#: src/components/ManagedAgentProvisioningStatus.tsx
msgid "The computer could not read its Agent configuration"
msgstr "电脑无法读取 Agent 配置"

#: src/components/ManagedAgentProvisioningStatus.tsx
msgid "The computer needs Node.js 22 or later. Update Node.js on this computer."
msgstr "电脑需要 Node.js 22 或更高版本。请在电脑上更新 Node.js。"

#: src/components/ManagedAgentProvisioningStatus.tsx
msgid "The computer still reports work in progress."
msgstr "电脑仍报告正在处理。"

#. placeholder {0}: node.machine_name
#: src/components/ComputerDetailView.tsx
msgid "The current connection token for \"{0}\" stops working immediately, so this computer goes offline right away. It stays offline until you re-run the new install command on it."
msgstr "“{0}”的当前连接令牌将立即失效，这台电脑会立刻离线。只有在电脑上重新运行新的安装命令后才会恢复连接。"

#: src/components/ComputerDetailView.tsx
msgid "The directory exists, but it is not a Git repository."
msgstr "目录存在，但不是 Git 仓库。"

#: src/components/ComputerDetailView.tsx
msgid "The directory is a Git repository, but none of its remotes match {repository}. Run git remote -v in that checkout and retry."
msgstr "该目录是 Git 仓库，但没有远程地址匹配 {repository}。请在仓库中运行 git remote -v 后重试。"

#: src/components/ComputerDetailView.tsx
msgid "The directory is outside this computer's exposed directories. Restart Remote Helper with --dirs to expose it, then retry."
msgstr "目录不在这台电脑的共享目录范围内。请使用 --dirs 重启 Remote Helper 以共享该目录，然后重试。"

#. placeholder {0}: status.exposed_dirs.join(', ')
#: src/components/ComputerDetailView.tsx
msgid "The directory must be inside one of this computer's exposed directories: {0}. Restart Remote Helper with --dirs if the checkout lives elsewhere."
msgstr "目录必须位于这台电脑的某个共享目录中：{0}。如果仓库位于其他位置，请使用 --dirs 重启 Remote Helper。"

#: src/components/AgentConnectResult.tsx
msgid "The directory this agent works in, not where the connector is installed."
msgstr "此 Agent 的工作目录，不是连接器的安装目录。"

#: src/components/ComputerDetailView.tsx
msgid "The directory was not found on the selected computer. Check the path and retry."
msgstr "在所选电脑上未找到该目录。请检查路径后重试。"

#: src/components/ManagedAgentProvisioningStatus.tsx
msgid "The installed runtime could not be verified. Check the helper logs on this computer."
msgstr "无法验证已安装的运行时。请检查这台电脑上的 Helper 日志。"

#. placeholder {0}: agent.display_name
#: src/components/AgentDetailView.tsx
msgid "The key can still be copied, but it will not authenticate while {0} is disabled, and it cannot be rotated until you enable it again."
msgstr "密钥仍可复制，但 {0} 禁用期间无法通过认证，也无法轮换密钥。请先重新启用。"

#: src/components/ManagedAgentProvisioningStatus.tsx
msgid "The runtime cannot reach a required service."
msgstr "运行时无法连接所需服务。"

#: src/components/ManagedAgentProvisioningStatus.tsx
msgid "The runtime could not be installed. Check the computer’s internet connection and package access."
msgstr "无法安装运行时。请检查电脑的网络连接和软件包访问权限。"

#: src/components/ManagedAgentProvisioningStatus.tsx
msgid "The runtime did not respond in time."
msgstr "运行时未能及时响应。"

#: src/components/ManagedAgentProvisioningStatus.tsx
msgid "The runtime installation is verified. Your saved setup is waiting for the next computer update."
msgstr "运行时安装已验证。已保存的设置正在等待电脑下次更新。"

#: src/components/ManagedAgentProvisioningStatus.tsx
msgid "The runtime reports an error. Check its connection settings and local logs."
msgstr "运行时报告错误。请检查连接设置和本地日志。"

#: src/components/ManagedAgentProvisioningStatus.tsx
msgid "The runtime reports an unexpected stop."
msgstr "运行时报告意外停止。"

#: src/components/ManagedAgentProvisioningStatus.tsx
msgid "The runtime reports that its API credentials are invalid."
msgstr "运行时报告 API 凭据无效。"

#: src/components/ManagedAgentProvisioningStatus.tsx
msgid "The runtime reports that its quota is exhausted."
msgstr "运行时报告配额已用完。"

#: src/components/ManagedAgentProvisioningStatus.tsx
msgid "The saved configuration has not been acknowledged. Check the helper logs on this computer."
msgstr "已保存的配置尚未被确认。请检查这台电脑上的 Helper 日志。"

#: src/components/ManagedAgentProvisioningStatus.tsx
msgid "The selected computer is no longer available"
msgstr "所选电脑已不可用"

#: src/components/ComputerDetailView.tsx
msgid "This action cannot be undone."
msgstr "此操作无法撤销。"

#: src/hooks/useAgentLifecycle.ts
msgid "This Agent has an unrestricted '*' permission grant and cannot be enabled. Clearing its permissions deletes all grants, so first read and save them with GET {permissionsPath}. Clear the entire set with PUT {permissionsPath} and an empty list. Then enable the Agent and restore the saved permissions with PUT {permissionsPath}, excluding every '*' grant at every scope."
msgstr "此 Agent 拥有不受限制的 '*' 权限，因此无法启用。清空权限会删除所有授权，请先通过 GET {permissionsPath} 读取并保存现有权限。然后通过 PUT {permissionsPath} 提交空列表以清空全部权限。启用 Agent 后，再通过 PUT {permissionsPath} 恢复之前保存的权限，并排除所有作用域中的每一项 '*' 授权。"

#: src/components/ManagedAgentProvisioningStatus.tsx
msgid "This Agent has no managed computer assigned. It can connect directly using its runtime."
msgstr "此 Agent 未分配托管电脑，可以使用其运行时直接连接。"

#: src/components/ComputerDetailView.tsx
msgid "This checklist confirms what will be removed before this computer is deleted for good."
msgstr "永久删除这台电脑前，请通过此清单确认将要移除的内容。"

#: src/components/DecommissionAgentModal.tsx
msgid "this computer"
msgstr "这台电脑"

#: src/components/ComputerDetailView.tsx
msgid "This computer does not have a saved mapping for that repository. Bind the checkout again, then retry."
msgstr "这台电脑没有为该仓库保存映射。请重新绑定仓库后重试。"

#: src/components/ManagedAgentProvisioningStatus.tsx
msgid "This configuration is waiting for the computer’s next setup attempt. The computer has not started this setup request."
msgstr "此配置正在等待电脑下次尝试设置。电脑尚未开始处理本次设置请求。"

#: src/components/ComputerDetailView.tsx
msgid "This connected helper does not support repository mappings. Update Remote Helper, then reconnect."
msgstr "当前连接的 Helper 不支持仓库映射。请更新 Remote Helper 后重新连接。"

#: src/components/ManagedAgentProvisioningStatus.tsx
msgid "This Helper version does not report setup progress. Update the Borgee helper on your computer to see setup progress."
msgstr "此 Helper 版本不会报告设置进度。请更新电脑上的 Borgee Helper 以查看设置进度。"

#: src/lib/openclaw-onboarding.ts
msgid "This lets Borgee read final-turn usage for telemetry. Borgee does not persist message content."
msgstr "这允许 Borgee 读取最终轮次的用量用于遥测。Borgee 不会持久化消息内容。"

#: src/components/AgentConnectResult.tsx
msgid "This lets Borgee read the final turn's usage. It does not persist message content."
msgstr "这允许 Borgee 读取最终轮次的用量，不会持久化消息内容。"

#: src/components/AgentDetailView.tsx
msgid "This member is a person, or an agent that no longer exists."
msgstr "此成员是人类用户，或是已不存在的 Agent。"

#: src/components/DecommissionAgentModal.tsx
msgid "This will not delete the computer or affect other hosted agents on it."
msgstr "这不会删除电脑，也不会影响电脑上的其他托管 Agent。"

#: src/components/ComputerDetailView.tsx
msgid "This will not delete this computer or affect any other hosted agents on it."
msgstr "这不会删除这台电脑，也不会影响上面的其他托管 Agent。"

#. placeholder {0}: node.machine_name
#: src/components/ComputerDetailView.tsx
msgid "This will permanently delete the agent and stop <0>{0}</0> from hosting it on the next remote-helper sync."
msgstr "这将永久删除 Agent，并在下次 remote-helper 同步时停止在 <0>{0}</0> 上托管。"

#: src/components/DecommissionAgentModal.tsx
msgid "This will remove <0>{agentName}</0> from all channels, disconnect it, and permanently delete the agent. This cannot be undone."
msgstr "这将从所有频道移除 <0>{agentName}</0>、断开连接并永久删除 Agent。此操作无法撤销。"

#: src/components/DecommissionAgentModal.tsx
msgid "This will remove <0>{agentName}</0> from all channels, stop <1>{hostedMachineLabel}</1> from hosting it, and permanently delete the agent. This will not delete the computer or affect any other hosted agents on it."
msgstr "这将从所有频道移除 <0>{agentName}</0>、停止在 <1>{hostedMachineLabel}</1> 上托管并永久删除 Agent。电脑及其上的其他托管 Agent 不受影响。"

#: src/lib/openclaw-onboarding.ts
msgid "To accept this invitation, add Borgee alongside your existing OpenClaw channels."
msgstr "要接受此邀请，请在保留现有 OpenClaw 频道的基础上添加 Borgee。"

#: src/components/AgentDetailView.tsx
#: src/components/AgentDisabledBanner.tsx
#: src/components/AgentSidebar.tsx
msgid "Try again"
msgstr "重试"

#: src/components/ManagedAgentProvisioningStatus.tsx
msgid "Try refreshing the status again. The Agent stays saved in your workspace."
msgstr "请再次尝试刷新状态。Agent 仍保存在工作区中。"

#: src/components/AgentDetailView.tsx
msgid "turn-full: each turn carries the full Borgee projection inline."
msgstr "turn-full：每个轮次都内联携带完整的 Borgee 投影。"

#: src/components/AgentDetailView.tsx
msgid "turn-thin: each turn keeps only a thin Borgee projection layer."
msgstr "turn-thin：每个轮次仅保留精简的 Borgee 投影层。"

#: src/lib/agent-state.ts
msgid "Unknown error"
msgstr "未知错误"

#: src/components/ComputerDetailView.tsx
msgid "Use an absolute path on the selected computer, then retry."
msgstr "请使用所选电脑上的绝对路径，然后重试。"

#. placeholder {0}: checked.repository
#. placeholder {1}: checked.path
#: src/components/ComputerDetailView.tsx
msgid "Verified {0} at {1}."
msgstr "已验证 {0} 位于 {1}。"

#: src/components/ComputerDetailView.tsx
msgid "Verify"
msgstr "验证"

#: src/components/ManagedAgentProvisioningStatus.tsx
msgid "Verifying"
msgstr "正在验证"

#: src/components/ManagedAgentProvisioningStatus.tsx
msgid "Verifying the agent runtime"
msgstr "正在验证 Agent 运行时"

#: src/components/ManagedAgentProvisioningStatus.tsx
msgid "View Agent"
msgstr "查看 Agent"

#: src/components/FailurePopover.tsx
msgid "View logs"
msgstr "查看日志"

#: src/components/DecommissionAgentModal.tsx
msgid "Waiting for {agentName} to go offline..."
msgstr "正在等待 {agentName} 离线..."

#: src/components/AgentManager.tsx
msgid "Waiting for <0>{createdName}</0> to connect..."
msgstr "正在等待 <0>{createdName}</0> 连接..."

#: src/components/DecommissionAgentModal.tsx
msgid "Waiting for hosted status..."
msgstr "正在等待托管状态..."

#: src/components/ManagedAgentProvisioningStatus.tsx
msgid "Waiting for setup status"
msgstr "正在等待设置状态"

#: src/components/ManagedAgentProvisioningStatus.tsx
msgid "Waiting for the computer to report this configuration."
msgstr "正在等待电脑报告此配置。"

#: src/components/ManagedAgentProvisioningStatus.tsx
msgid "Waiting for your computer"
msgstr "正在等待你的电脑"

#: src/components/ManagedAgentProvisioningStatus.tsx
msgid "Waiting for your computer to apply the setup"
msgstr "正在等待电脑应用设置"

#: src/components/ManagedAgentProvisioningStatus.tsx
msgid "Waiting to apply"
msgstr "等待应用"

#: src/components/AgentManager.tsx
msgid "What agent do you have?"
msgstr "你使用什么 Agent？"

#: src/components/InviteAgentModal.tsx
msgid "What's your agent's name? They'll join <0>Borgee</0> with default permissions."
msgstr "你的 Agent 叫什么名字？它将使用默认权限加入 <0>Borgee</0>。"

#: src/lib/agent-state.ts
msgid "Working"
msgstr "工作中"

#: src/components/ManagedAgentProvisioningStatus.tsx
msgid "You can close this window. {agentName} will stay in your workspace."
msgstr "你可以关闭此窗口。{agentName} 将保留在工作区中。"

#: src/components/PermissionsView.tsx
msgid "You do not have permission to view grants"
msgstr "你无权查看授权"

#: src/components/AgentConfigPanel.tsx
msgid "You have unsaved Agent configuration changes. Leave and discard them?"
msgstr "Agent 配置有未保存的改动。离开并放弃这些改动吗？"

#: src/components/AgentManager.tsx
msgid "You no longer have permission to add agents to this Project."
msgstr "你已无权向此项目添加 Agent。"

#: src/components/ManagedAgentProvisioningStatus.tsx
msgid "You’re offline"
msgstr "你已离线"

#: src/components/AgentManager.tsx
msgid "your agent"
msgstr "你的 Agent"

#: src/components/AgentManager.tsx
msgid "Your agent"
msgstr "你的 Agent"

#: src/components/AgentManager.tsx
msgid "Your Agent"
msgstr "你的 Agent"

#: src/components/HostedAgentCreated.tsx
msgid "Your computer"
msgstr "你的电脑"

#: src/components/ManagedAgentProvisioningStatus.tsx
msgid "Your computer is offline"
msgstr "你的电脑已离线"

#: src/components/ManagedAgentProvisioningStatus.tsx
msgid "Your computer is preparing the saved Agent configuration."
msgstr "电脑正在准备已保存的 Agent 配置。"

#: src/components/InviteAgentModal.tsx
msgid "Your first channel is #welcome.<0/>Say hello when you get here — someone is waiting.<1/>— {ownerName}"
msgstr "你的第一个频道是 #welcome。<0/>到了就打声招呼，有人在等你。<1/>—— {ownerName}"
